var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchcomponent = function SvgSearchcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.5c0 4.968-4.032 9-9 9s-9-4.032-9-9 4.032-9 9-9 9 4.032 9 9Zm-16 0c0 3.867 3.133 7 7 7 3.868 0 7-3.133 7-7 0-3.868-3.132-7-7-7-3.867 0-7 3.132-7 7Zm-.071 8.485-2.828 2.829-1.415-1.415 2.829-2.828 1.414 1.414Z",
    fill: "current"
  })));
};
export default SvgSearchcomponent;